import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/builds/RuStore-Web/monoland/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppCard"] */ "/builds/RuStore-Web/monoland/packages/shared/AppCard/AppCard.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/shared/NotFound/assets/404.webp");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/shared/NotFound/NotFound.module.scss");
